import React from 'react';
import AddTicket from '../../shared/AddTicket/AddTicket';
import BetSlip from '../../BetSlip/BetSlip';
import PreMatchSportsNav from '../../Sports/SportsNav/PreMatchSports';
import PreMatchesLayout from './PreMatchesLayout';
import LiveLayout from './LiveLayout';

import styles from './Layout.module.scss';

const EventsLayout = props => {
    const { isLive, children } = props;

    return (
        <div className={`${styles.eventsLayout} ${isLive ? styles.live : ''}`}>
            <AddTicket />
            <div className={styles.layoutWrapper}>
                {!isLive && (
                    <div className={styles.navigationArea}>
                        <PreMatchSportsNav />
                    </div>
                )}
                <div className={styles.contentArea}>
                    {isLive ? (
                        <LiveLayout>{children}</LiveLayout>
                    ) : (
                        <PreMatchesLayout>{children}</PreMatchesLayout>
                    )}
                </div>
                <div className={styles.betSlipArea}>
                    <BetSlip isLive={isLive} />
                </div>
            </div>
        </div>
    );
};

export default EventsLayout;
